import { Button, List, Row, Select, Skeleton } from "antd";
import { RootState } from "../../../../app/store";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  initList,
  loadMore,
  setYear,
  getCreationYearsStats,
} from "./creationPanelSlice";
import { URLS } from "../../../../utils-creation/constants";
import { Creation } from "../../../../utils-creation/types";
import CreationTitle from "../../../../components/creation/CreationTitle";
import CreationDescription from "../../../../components/creation/CreationDescription";
import TotalResult from "../../../../components/panel/TotalResult";
import Error500 from "../../../../components/errors/Error500";
import ToHomeButton from "../../../../components/ToHomeButton";

const { Option } = Select;

export default function CreationPanel() {
  const dispatch = useDispatch();

  const { user } = useSelector((state: RootState) => state.authentication);

  const {
    creationsList,
    status,
    total,
    hasNext,
    yearFilter: {
      years,
      year: selectedYear,
      total: total_yearFilter,
      status: status_yearFilter,
    },
  } = useSelector((state: RootState) => state.creationPanel);

  useEffect(() => {
    if (user) {
      dispatch(initList({ randomID: user.random_id, year: selectedYear }));
    }
  }, [dispatch, user, selectedYear]);

  useEffect(() => {
    if (user) {
      dispatch(getCreationYearsStats(user.random_id));
    }
  }, [dispatch, user]);

  if (status === "failed") return <Error500 extra={<ToHomeButton />} />;

  return (
    <>
      <Row justify="center">
        <Link to={URLS.RESEARCH_CREATION_NEW}>
          <Button type="primary" className="sub-heading-font">
            ADD NEW
          </Button>
        </Link>
      </Row>

      {total >= 0 && <TotalResult searchResult={total} />}

      {total_yearFilter >= 0 && (
        <Select
          className="sub-heading-font"
          value={selectedYear}
          style={{ width: 200, marginRight: 8, marginBottom: 4 }}
          onChange={(value) => {
            dispatch(setYear(value));
          }}
          loading={status_yearFilter !== "succeeded"}
          disabled={status_yearFilter !== "succeeded"}
          filterOption={(input, option) =>
            option !== undefined &&
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {[
            <Option className="sub-heading-font" value={-1} key={-1}>
              {`All premiere years (${total_yearFilter})`}
            </Option>,
            ...years.map((x) => (
              <Option className="sub-heading-font" value={x.year} key={x.year}>
                {`${x.year} (${x.count})`}
              </Option>
            )),
          ]}
        </Select>
      )}

      <List
        loading={status === "idle"}
        itemLayout="horizontal"
        loadMore={
          hasNext ? (
            <div
              style={{
                textAlign: "center",
                marginTop: 12,
                height: 32,
                lineHeight: "32px",
              }}
            >
              <Button
                className="sub-heading-font"
                onClick={() =>
                  user &&
                  dispatch(
                    loadMore({ randomID: user.random_id, year: selectedYear })
                  )
                }
              >
                More
              </Button>
            </div>
          ) : null
        }
        dataSource={creationsList}
        renderItem={(item) => {
          const creation = item.item as Creation;
          return (
            <List.Item>
              <Skeleton title={false} loading={item.loading} active>
                <List.Item.Meta
                  title={<CreationTitle creation={creation} />}
                  description={
                    <CreationDescription creation={creation} isSettingsPage />
                  }
                />
              </Skeleton>
            </List.Item>
          );
        }}
      />
    </>
  );
}
